export const EDIT_USER = "edit_user";
